import React from 'react';
import { mockData } from '../mock/mockData';

const Memes = () => {
  const { memes } = mockData;

  return (
    <section id="memes" className="memes-section">
      <div className="section-container">
        <h2 className="section-title">{memes.title}</h2>
        <p className="section-subtitle">{memes.subtitle}</p>
        
        <div className="memes-grid">
          {memes.images.map((image, index) => (
            <div key={index} className="meme-card">
              <img 
                src={image}
                alt={`Meme ${index + 1}`}
                className="meme-image"
              />
              <div className="meme-overlay">
                <span className="meme-text">Supreme Meme #{index + 1}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Memes;
